import { Injectable, NgZone } from '@angular/core'
import { GoogleMapsAPIWrapper } from 'angular2-google-maps/core'
import { MapsAPILoader } from 'angular2-google-maps/core'
import { Observable, Observer } from 'rxjs'

declare var google: any;

@Injectable()
export class GMapService extends GoogleMapsAPIWrapper {
	constructor(private __loader: MapsAPILoader, private __zone: NgZone) {
		super(__loader, __zone)
	}

	getLatLan(address: string) {
		//console.log('Getting Address - ', address)
		let geocoder = new google.maps.Geocoder()
		//console.log('PASS 0 - ', geocoder)
		return Observable.create(observer => {
			//console.log('PASS 1 - ', address)
			geocoder.geocode({ 'address': address }, function (results, status) {
				//console.log('PASS 2 - ', address)
				if (status == google.maps.GeocoderStatus.OK) {
					observer.next(results[0].geometry.location)
					observer.complete()
				} else {
					console.log('Error - ', results, ' & Status - ', status)
					observer.next({'error': true})
					observer.complete()
				}
			});
		})
	}
}



// WEBPACK FOOTER //
// D:/jordan/stunii-cms-stunii-cms-Appzorro1/stunii-cms-stunii-cms-Appzorro1/src/app/services/gmap.service.ts